import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { TableCellType } from "components/LazyTable";
import SortableTable from "components/SortableTable";
import StatusChip from "components/StatusChip";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import { FormattedMessage as T, useIntl } from "react-intl";
import {
  ListRequestOfApplicationUserFilter,
  ListResponseOfApplicationUser,
} from "services/KnowfullyAdminClient";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

const ApplicationUserList = ({ userId }: { userId: string }) => {
  const { formatMessage: t } = useIntl();
  const { applicationUserService } = useGlobalContext();
  const [expanded, setExpanded] = useState(false);

  const { data, isFetching } = useStrictQuery<ListResponseOfApplicationUser>(
    ["applicationUserDetailsList", userId],
    () =>
      applicationUserService.getApplicationUsersByOrganizationUserId(
        ListRequestOfApplicationUserFilter.fromJS({
          parameters: { organizationUserId: userId },
          sortField: "application.Name",
        })
      ),
    { enabled: expanded }
  );

  const cells: Array<TableCellType> = [
    {
      accessor: "applicationName",
      type: "text",
      label: t({ id: "applicationLabel" }),
    },
    {
      accessor: "userStatusTypeName",
      width: 130,
      type: "node",
      label: t({ id: "statusLabel" }),
      View: StatusChip,
    },
  ];

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>
          <T id="applicationsTitle" />
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box mb={2}>
          <SortableTable
            {...{
              rows: data?.data!,
              loading: isFetching,
              dense: true,
              cells,
              tableRowPerPage: 5,
            }}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default withErrorBoundary(ApplicationUserList);
